import React from 'react';
import "../assets/Main.css";
import { motion } from 'framer-motion';
import MixedFlower from "../assets/images/Flower-Mix.svg";
import Midflower from "../assets/images/mid.svg";
import monoMid from "../assets/images/SDMono.svg";
import btnDate from "../assets/images/btn.svg";
import frameImg from "../assets/images/TopFrame.svg";
import Butterfly from './Butterfly';
import LeafFall from './Leaf';
import Logo from './Logo';
import Timeline from './Timeline';
import MapQR from './Map';
import Countdown from './Coundown';
import Photo from './Photo';
import Wish from './Wish';


// Butterflies
const butterflies = [];
for (let i = 0; i < 18; i++) {
  butterflies.push(
    <motion.div
      key={i}
      style={{ position: 'absolute', top: `${Math.random() * 80}%`, left: `${Math.random() * 100}%` }}
      animate={{
        y: [0, -15 + Math.random() * 30, 0],
        x: [0, -10 + Math.random() * 20, 0],
        rotate: [0, 15, -15, 0],
      }}
      transition={{ repeat: Infinity, duration: 4 + Math.random() * 3, ease: "easeInOut", delay: Math.random() * 2 }}
    >
      <Butterfly direction={Math.random() > 0.5 ? 'left' : 'right'} size={0.5 + Math.random() * 1} />
    </motion.div>
  );
}

const Main = () => {
  return (
    <div className="cover-containerM">
      {/* Frame overlay */}
      <div className="frame-overlay">
        <img src={frameImg} alt="Decorative Frame" className="full-frame" />
      </div>

      {/* Frame overlay (fixed, always above content) */}
      <div className="frame-overlay">
        

        {butterflies}
      </div>

      {/* Scrollable content */}
      <div className="content">
        {/* <img src={monoMid} alt="mono mid top" className="monoMidTop" /> */}
        <img src={monoMid} alt="mono mid center" className="monoMidCenter" />

        <motion.div 
          className='mono-Main-Tittle'
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          សិរីមង្គលអាពាហ៍ពិពាហ៍
        </motion.div>

       <motion.div 
  className='dadNames'
  initial={{ opacity: 0, x: -50 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8 }}
>
  <h6 style={{ fontSize: "13px" }}>លោក ម៉ក់ ចាន់តារា</h6>
  <h6 style={{ fontSize: "13px" }}>លោក អៀម វិសាល</h6>
</motion.div>

<motion.div 
  className='momNames'
  initial={{ opacity: 0, x: -50 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8 }}
>
  <h6 style={{ fontSize: "13px" }}>លោកស្រី អ៊ុន សូលីដា</h6>
  <h6 style={{ fontSize: "13px" }}>លោកស្រី ស៊ុយ ស៊ីណា</h6>
</motion.div>


        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <h4 className='invite'>សូមគោរពអញ្ជើញ</h4>
          <h6 className='sub-invite' style={{ fontSize: "11px" }}>
            ឯកឧត្ដម អ្នកឧកញ៉ា លោកឧកញ៉ា លោកជំទាវ លោក លោកស្រី អ្នកនាងកញ្ញា អញ្ជើញចូលរួមជាអធិបតីយភាព និងជាភ្ញៀវកិត្តិយស ចម្រើន ជោគជ័យ សិរីសួស្តី ក្នុងកម្មវិធីសិរីមង្គលអាពាហ៍ពិពាហ៍ កូនប្រុស កូនស្រី របស់យើងខ្ញុំ។
          </h6>
        </motion.div>

        <motion.div
          className='bride-groom-tittle'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className='groom-title'>កូនប្រុសនាម</span>
          <span className='middle-text'>ជាគូនឹង</span>
          <span className='bride-title'>កូនស្រីនាម</span>
        </motion.div>

        <motion.div
          className='groomBridename'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <span className='groom-name'>ទូច ច័ន្ទចេស្តា</span>
          <span className='bride-name'>វិសាល សុបញ្ញា</span>
        </motion.div>

        <motion.div
          className='date'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <h6>ដែលនឹងប្រព្រឹត្តទៅនៅ</h6>
          <h6>ថ្ងៃ អាទិត្យ ទី១៦ ខែ វិច្ឆិកា ២០២៥</h6>
          <h6>នៅមណ្ឌល សន្និបាត និងពិព័រណ៍កោះពេជ្រ ( អគារ E )</h6>
        </motion.div>

        <div className="btnDate-container">
          <img
  src={btnDate}
  alt="flower"
  className="btnDate"
  onClick={() => {
    const calendarLink =
      "https://calendar.google.com/calendar/render?action=TEMPLATE&text=សិរីមង្គលអាពាហ៍ពិពាហ៍ចេស្តានិងសុបញ្ញា&dates=20251116T113000Z/20251116T150000Z&details=សូមគោរពអញ្ជើញ%0Aឯកឧត្ដម%20អ្នកឧកញ៉ា%20លោកឧកញ៉ា%20លោកជំទាវ%20លោក%20លោកស្រី%20អ្នកនាងកញ្ញា%20អញ្ជើញចូលរួមជាអធិបតីយភាព%20និងជាភ្ញៀវកិត្តិយស%20ចម្រើន%20ជោគជ័យ%20សិរីសួស្តី%20ក្នុងកម្មវិធីសិរីមង្គលអាពាហ៍ពិពាហ៍%20កូនប្រុស%20កូនស្រី%20របស់យើងខ្ញុំ។&location=នៅមណ្ឌល%20សន្និបាត%20និងពិព័រណ៍កោះពេជ្រ%20(%20អគារ%20E%20)%20រាជធានីភ្នំពេញ";
    window.open(calendarLink, "_blank");
  }}
/>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <h3 className="event">កម្មវិធីសិរីមង្គលអាពាហ៍ពិពាហ៍</h3>
          <h5 className="sub-event">ថ្ងៃ អាទិត្យ ទី១៦ ខែ វិច្ឆិកា ២០២៥</h5>
          <h5 className="date1 mb-5 mt-3">កម្មវិធីពេលព្រឹក</h5>
          <Timeline/>
        </motion.div>

        <motion.div
          className="eventItem"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1, duration: 0.8 }}
        >
          <h5 className="date2 mb-3">កម្មវិធីពេលល្ងាច</h5>
          <h5 className="eventDetailTime mb-3">ម៉ោង ០៥:០០ ល្ងាច</h5>
          <p className="eventDetail">
            អញ្ជើញភ្ញៀវកិត្តិយសពិសារភោជនាហាពេលល្ងាចស្ថិតនៅនៅមណ្ឌល សន្និបាត និងពិព័រណ៍កោះពេជ្រ ( អគារ E ) ដោយមេត្រីភាព សូមអរគុណ។
          </p>
        </motion.div>
        <MapQR/>
        

        <div className="mix-flower-container main">
  <img src={MixedFlower} alt="Flower Left" className="main-mix-flower left" />
  <img src={Midflower} alt="Flower Center Left" className="main-mix-flower center-left" />
  <img src={Midflower} alt="Flower Center Right" className="main-mix-flower center-right" />
  <img src={MixedFlower} alt="Flower Right" className="main-mix-flower right" />
</div>



       
     
        <Countdown/>
        <Photo/>
        <Wish/>
        <Logo/>
        <LeafFall/>
      </div>
    </div>
  );
};

export default Main;
